import type { SVGProps } from 'react';
import { icons, type IconName } from './icons-map';
import styles from './Icon.module.css';

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'ref'> {
  name: IconName;
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  color?: 'primary' | 'secondary' | 'disabled' | 'brand' | 'success' | 'error' | 'warning' | 'info' | 'inverse' | 'inherit';
}

export function Icon({ name, size = 'md', color = 'primary', className, ...props }: IconProps) {
  const SvgIcon = icons[name];

  if (!SvgIcon) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  const classes = [styles.icon, styles[size], styles[color], className].filter(Boolean).join(' ');

  return <SvgIcon className={classes} {...props} />;
}

Icon.displayName = 'Icon';
